import axios from 'axios';

const clients = {};

const apiClient = (backend) => {
  if (clients[backend]) {
    return clients[backend];
  }

  let baseURL;
  if (backend === 'survey') {
    baseURL = process.env.REACT_APP_SURVEY_BACKEND_URL;
  } else if (backend === 'iam') {
    baseURL = process.env.REACT_APP_IAM_BACKEND_URL;
  } else if (backend === 'transcription') {
    baseURL = process.env.REACT_APP_TRANSCRIPTION_BACKEND_URL;
  } else if (backend === 'emotions') {
    baseURL = process.env.REACT_APP_EMOTIONS_BACKEND_URL;
  } else if (backend === 'sentiment') {
    baseURL = process.env.REACT_APP_SENTIMENT_BACKEND_URL;
  } else {
    throw new Error('Unknown backend');
  }

  const instance = axios.create({
    baseURL,
    withCredentials: true, // send cookies automatically
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Prevent infinite retry loop for /refresh endpoint
      if (originalRequest.url.includes('/refresh')) {
        return Promise.reject(error);
      }

      console.log('refreshing token');

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          // Refresh the token via IAM client
          const iamClient = apiClient('iam');
          await iamClient.post('/iam/refresh');

          // Retry original request
          return instance(originalRequest);
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          // window.location.href = "/iam/login";
        }
      }

      return Promise.reject(error);
    }
  );

  clients[backend] = instance;
  return instance;
};

export default apiClient;
